import React, { Component } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  Divider,
  Stack,
  Avatar,
  Chip,
} from "@mui/material";

// Ícones MUI
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PhoneIcon from "@mui/icons-material/Phone";
import StorefrontIcon from "@mui/icons-material/Storefront";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import { Link } from "react-router-dom";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyName: "fazpedido.com.br",
      companyDescription:
        "Plataforma completa de catálogo online, loja virtual e PDV integrado. Venda sem pagar taxas por pedido, sincronize seu estoque e automatize suas vendas no balcão, Instagram e WhatsApp.",
      socialLinks: [
        { name: "Instagram", href: "https://www.instagram.com/fazpedido.app", icon: <InstagramIcon fontSize="small" /> },
        { name: "Facebook", href: "https://www.facebook.com/fazpedido.app", icon: <FacebookIcon fontSize="small" /> },
        { name: "WhatsApp", href: "https://wa.me/5511981799101", icon: <WhatsAppIcon fontSize="small" /> },
        { name: "Telefone", href: "tel:+5511981799101", icon: <PhoneIcon fontSize="small" /> },
      ],
      menuColumns: [
        {
          title: "Módulos & Recursos",
          links: [
            { name: "Catálogo Digital & Loja Virtual", href: "/solucoes/catalogo-digital" },
            { name: "Módulo PDV (Frente de Caixa)", href: "/solucoes/pdv-frente-de-caixa" },
            { name: "Controle de Estoque & Grades", href: "/solucoes/controle-de-estoque" },
            { name: "Impressão Térmica Automatizada", href: "/solucoes/impressao-termica" },
            { name: "Gestão de Entregas & Frete por CEP", href: "/solucoes/gestao-de-entregas" },
            { name: "Comandas & Controle de Mesas", href: "/solucoes/comandas-e-mesas" },
            { name: "Ordens de Serviço (O.S.)", href: "/solucoes/ordem-de-servico" },
            { name: "Planos e Preços", href: "/#planos" },
          ],
        },
        {
          title: "Soluções por Segmento",
          links: [
            { name: "Alimentação & Delivery", href: "/segmentos/delivery-restaurantes" },
            { name: "Moda & Vestuário", href: "/segmentos/loja-de-roupas" },
            { name: "Eletrônicos & Informática", href: "/segmentos/eletronicos" },
            { name: "Casa, Decor & Variedades", href: "/segmentos/variedades" },
            { name: "Cosméticos & Perfumaria", href: "/segmentos/cosmeticos" },
            { name: "Assistência Técnica & Serviços", href: "/segmentos/assistencia-tecnica" },
            { name: "Mercados & Conveniências", href: "/segmentos/mercado-conveniencia" },
          ],
        },
        {
          title: "Ferramentas & SEO",
          links: [
            { name: "Gerador de Cardápio Digital Grátis", href: "/ferramentas/gerador-cardapio-digital" },
            { name: "Gerador de Link de WhatsApp", href: "/ferramentas/gerador-link-whatsapp" },
            { name: "Criador de QR Code para Mesa", href: "/ferramentas/gerador-qr-code" },
            { name: "Calculadora de Margem de Lucro", href: "/ferramentas/calculadora-margem" },
            { name: "Casos de Sucesso & Depoimentos", href: "/#resultados" },
            { name: "Demonstração Interativa", href: "/demo" },
          ],
        },
        {
          title: "Empresa & Suporte",
          links: [
            { name: "Sobre o FazPedido", href: "/sobre" },
            { name: "Central de Ajuda & Tutoriais", href: "https://blog.fazpedido.com.br" },
            { name: "Blog de Gestão Comunitária", href: "/blog" },
            { name: "Contato & Suporte Técnico", href: "mailto:contato@fazpedido.com.br" },
            { name: "Status do Sistema", href: "/status" },
          ],
        },
      ],
    };
  }

  render() {
    // Schema Structured Data para SEO Local e Organização (Google Rich Snippets)
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "FazPedido",
      "operatingSystem": "Web, Android, iOS, Windows",
      "applicationCategory": "BusinessApplication",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "BRL"
      },
      "publisher": {
        "@type": "Organization",
        "name": "FazPedido",
        "url": "https://fazpedido.com.br",
        "logo": "https://fazpedido.com.br/logo.png",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Praça Padre João Álvares, 146 - Centro",
          "addressLocality": "Itaquaquecetuba",
          "addressRegion": "SP",
          "postalCode": "08570-050",
          "addressCountry": "BR"
        }
      }
    };

    return (
      <Box
        component="footer"
        sx={{
          borderTop: "1px solid #E3E1F8",
          bgcolor: "#FAF8FF",
          pt: 8,
          pb: 6,
        }}
      >
        {/* Injeção de dados estruturados para SEO do Google */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
        />

        <Container maxWidth="xl">
          {/* Banner de Chamada para Ação (CTA) */}
          <Box
            sx={{
              bgcolor: "#7C3AED",
              borderRadius: "16px",
              p: { xs: 3, md: 5 },
              mb: 8,
              color: "#FFFFFF",
              boxShadow: "0 10px 25px rgba(124, 58, 237, 0.25)",
            }}
          >
            <Grid container spacing={3} alignItems="center">
              <Grid size={{ xs: 12, md: 8 }}>
                <Stack direction="row" alignItems="center" gap={1} mb={1}>
                  <Chip
                    icon={<RocketLaunchIcon style={{ color: "#FFF", fontSize: 16 }} />}
                    label="Sem taxa por pedido"
                    size="small"
                    sx={{ bgcolor: "rgba(255, 255, 255, 0.2)", color: "#FFF", fontWeight: 700 }}
                  />
                </Stack>
                <Typography variant="h4" sx={{ fontWeight: 800, letterSpacing: "-0.5px" }}>
                  Pronto para escalar as vendas do seu comércio?
                </Typography>
                <Typography variant="body1" sx={{ opacity: 0.9, mt: 1 }}>
                  Crie seu catálogo digital, organize o PDV da sua loja e pare de pagar comissões abusivas hoje mesmo.
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, md: 4 }} textAlign={{ xs: "left", md: "right" }}>
                <Button
                  href="/auth/register"
                  variant="contained"
                  size="large"
                  sx={{
                    bgcolor: "#FFFFFF",
                    color: "#7C3AED",
                    fontWeight: 800,
                    px: 4,
                    py: 1.5,
                    borderRadius: "10px",
                    textTransform: "none",
                    fontSize: "1rem",
                    "&:hover": {
                      bgcolor: "#F2ECFF",
                    },
                  }}
                >
                  Criar Minha Loja Grátis
                </Button>
              </Grid>
            </Grid>
          </Box>

          <Grid container spacing={5} justifyContent="space-between">
            {/* Coluna Principal: Marca e Apresentação */}
            <Grid size={{ xs: 12, lg: 3 }}>
              <Stack
                spacing={2.5}
                alignItems={{ xs: "center", lg: "flex-start" }}
                textAlign={{ xs: "center", lg: "left" }}
              >
                <Box display="flex" alignItems="center" gap={1.5}>
                  <Avatar
                    sx={{
                      bgcolor: "rgba(124, 58, 237, 0.12)",
                      color: "#7C3AED",
                      width: 44,
                      height: 44,
                      borderRadius: "12px",
                    }}
                  >
                    <StorefrontIcon />
                  </Avatar>
                  <Typography
                    variant="h5"
                    sx={{ fontWeight: 800, color: "#1E1B4B", letterSpacing: "-0.5px" }}
                  >
                    {this.state.companyName}
                  </Typography>
                </Box>

                <Typography
                  variant="body2"
                  sx={{ color: "#464467", maxWidth: 360, lineHeight: 1.6 }}
                >
                  {this.state.companyDescription}
                </Typography>

                {/* Redes Sociais */}
                <Stack
                  direction="row"
                  flexWrap="wrap"
                  gap={1}
                  justifyContent={{ xs: "center", lg: "flex-start" }}
                >
                  {this.state.socialLinks.map((link) => (
                    <Button
                      key={link.name}
                      variant="outlined"
                      startIcon={link.icon}
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      size="small"
                      sx={{
                        borderRadius: "50px",
                        textTransform: "none",
                        borderColor: "#D8D4FE",
                        color: "#464467",
                        bgcolor: "#ffffff",
                        fontWeight: 600,
                        fontSize: "0.85rem",
                        px: 2,
                        py: 0.8,
                        "&:hover": {
                          borderColor: "#7C3AED",
                          bgcolor: "#F2ECFF",
                          color: "#7C3AED",
                        },
                      }}
                    >
                      {link.name}
                    </Button>
                  ))}
                </Stack>
              </Stack>
            </Grid>

            {/* Colunas de Links Estruturados para SEO */}
            <Grid size={{ xs: 12, lg: 9 }}>
              <Grid container spacing={3}>
                {this.state.menuColumns.map((col) => (
                  <Grid size={{ xs: 12, sm: 6, md: 3 }} key={col.title}>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        textTransform: "uppercase",
                        fontWeight: 700,
                        color: "#1E1B4B",
                        fontSize: "0.82rem",
                        letterSpacing: "0.5px",
                        mb: 2,
                        textAlign: { xs: "center", sm: "left" },
                      }}
                    >
                      {col.title}
                    </Typography>
                    <Stack
                      spacing={1.3}
                      alignItems={{ xs: "center", sm: "flex-start" }}
                    >
                      {col.links.map((link) => (
                        <Link
                          key={link.name}
                          to={link.href}
                          underline="none"
                          sx={{
                            color: "#464467",
                            fontSize: "0.88rem",
                            fontWeight: 500,
                            transition: "color 0.2s ease",
                            "&:hover": {
                              color: "#7C3AED",
                              textDecoration: "underline",
                            },
                          }}
                        >
                          {link.name}
                        </Link>
                      ))}
                    </Stack>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>

          <Divider sx={{ my: 5, borderColor: "#E3E1F8" }} />

          {/* Rodapé Inferior: Informações Legais, CNPJ e SEO Local */}
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems="center"
            spacing={3}
            textAlign={{ xs: "center", md: "left" }}
          >
            <Box>
              <Typography variant="body2" sx={{ color: "#1E1B4B", fontWeight: 600 }}>
                © 2026 {this.state.companyName}. Todos os direitos reservados.
              </Typography>
              <Typography variant="caption" sx={{ color: "#6B6790", display: "block", mt: 0.5 }}>
                CNPJ: 68.006.678/0001-15 | Praça Padre João Álvares, 146 - Centro, Itaquaquecetuba - SP, 08570-050
              </Typography>
            </Box>

            <Stack direction="row" spacing={2}>
              <Button
                href="/terms"
                size="small"
                variant="text"
                sx={{
                  textTransform: "none",
                  color: "#464467",
                  fontWeight: 600,
                  "&:hover": { color: "#7C3AED", bgcolor: "transparent" },
                }}
              >
                Termos de Uso
              </Button>
              <Button
                href="/privacy"
                size="small"
                variant="text"
                sx={{
                  textTransform: "none",
                  color: "#464467",
                  fontWeight: 600,
                  "&:hover": { color: "#7C3AED", bgcolor: "transparent" },
                }}
              >
                Política de Privacidade
              </Button>
            </Stack>
          </Stack>
        </Container>
      </Box>
    );
  }
}

export default Footer;